// i18n area 'auth' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da auth.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/auth.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './auth'

export const ptBR: DeepPartial<typeof enUS> = {
  login: {
    username: 'Nome de usuário',
    usernamePlaceholder: 'Introduza o nome de usuário',
    usernameHint: 'Use usuário@domínio para se autenticar num realm de diretório',
    password: 'Senha',
    forgotPassword: 'Esqueceu a senha?',
    invalidCredentials: 'Nome de usuário ou senha inválidos',
    realmUnavailable: 'O realm não pode verificar as credenciais neste momento — o store do cluster não está acessível. Inicie sessão como usuário local (break-glass).'
  },
  user: {
    password: {
      menu: 'Alterar senha',
      title: 'Altere a sua senha',
      current: 'Senha atual',
      new: 'Nova senha',
      confirm: 'Confirmar nova senha',
      error: 'Não foi possível alterar a senha',
      forcedTitle: 'Altere a senha para continuar',
      forcedHint: 'Esta senha foi definida por um administrador e tem de ser substituída antes de entrar.'
    },
    mfa: {
      removeHint: 'A conta volta a ter apenas a senha. Pode voltar a configurar o segundo fator quando quiser.'
    }
  }
}
